export default __webpack_public_path__ + "static/media/thumb_5.d3105a9d.webp";